import { DoqFaceSvgProps } from '../types';

const TagscapeError = ({ size, className }: DoqFaceSvgProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 320 320"
    className={className}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="presentation"
  >
    <g clipPath="url(#clip0_2667_52841)">
      {/* mask to hide the bottom outline of the circle */}
      <mask id="bottom-mask-tagscape-error">
        <circle cx="160" cy="160" r="160" fill="white" />
        <path d="M 240,300 A 160,160 0 0,1 80,300 L 160,160 Z" fill="black" />
      </mask>
      <circle
        cx="160"
        cy="160"
        r="160"
        fill="#8800FF"
        mask="url(#bottom-mask-tagscape-error)"
      />
      <mask
        id="mask0_1240_23450"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="320"
        height="320"
      >
        <circle cx="160" cy="160" r="160" fill="#FCBF4C" />
      </mask>
      <g mask="url(#mask0_1240_23450)">
        <rect x="80" y="120" width="160" height="200" fill="white" />
      </g>
      <path
        d="M142 184C146.418 184 150 180.418 150 176C150 171.582 146.418 168 142 168C137.582 168 134 171.582 134 176C134 180.418 137.582 184 142 184Z"
        fill="#2974C4"
      />
      <path
        d="M178 184C182.418 184 186 180.418 186 176C186 171.582 182.418 168 178 168C173.582 168 170 171.582 170 176C170 180.418 173.582 184 178 184Z"
        fill="#2974C4"
      />
      <g opacity="0.5">
        <path
          d="M100 240C97.7909 240 96 241.791 96 244C96 246.209 97.7909 248 100 248H116C118.209 248 120 246.209 120 244C120 241.791 118.209 240 116 240H100Z"
          fill="#2974C4"
        />
        <path
          d="M100 256C97.7909 256 96 257.791 96 260C96 262.209 97.7909 264 100 264H132C134.209 264 136 262.209 136 260C136 257.791 134.209 256 132 256H100Z"
          fill="#2974C4"
        />
        <path
          d="M224 292C224 289.791 222.209 288 220 288H188C185.791 288 184 289.791 184 292C184 294.209 185.791 296 188 296H220C222.209 296 224 294.209 224 292Z"
          fill="#2974C4"
        />
        <path
          d="M132 240C129.791 240 128 241.791 128 244C128 246.209 129.791 248 132 248H148C150.209 248 152 246.209 152 244C152 241.791 150.209 240 148 240H132Z"
          fill="#2974C4"
        />
        <path
          d="M160 244C160 241.791 161.791 240 164 240H196C198.209 240 200 241.791 200 244C200 246.209 198.209 248 196 248H164C161.791 248 160 246.209 160 244Z"
          fill="#2974C4"
        />
        <path
          d="M212 240C209.791 240 208 241.791 208 244C208 246.209 209.791 248 212 248H220C222.209 248 224 246.209 224 244C224 241.791 222.209 240 220 240H212Z"
          fill="#2974C4"
        />
        <path
          d="M192 260C192 257.791 193.791 256 196 256H220C222.209 256 224 257.791 224 260C224 262.209 222.209 264 220 264H196C193.791 264 192 262.209 192 260Z"
          fill="#2974C4"
        />
        <path
          d="M172 288C174.209 288 176 289.791 176 292C176 294.209 174.209 296 172 296H148C145.791 296 144 294.209 144 292C144 289.791 145.791 288 148 288H172Z"
          fill="#2974C4"
        />
        <path
          d="M144 260C144 257.791 145.791 256 148 256H156C158.209 256 160 257.791 160 260C160 262.209 158.209 264 156 264H148C145.791 264 144 262.209 144 260Z"
          fill="#2974C4"
        />
        <path
          d="M108 272C110.209 272 112 273.791 112 276C112 278.209 110.209 280 108 280H100C97.7909 280 96 278.209 96 276C96 273.791 97.7909 272 100 272H108Z"
          fill="#2974C4"
        />
        <path
          d="M168 260C168 257.791 169.791 256 172 256H180C182.209 256 184 257.791 184 260C184 262.209 182.209 264 180 264H172C169.791 264 168 262.209 168 260Z"
          fill="#2974C4"
        />
        <path
          d="M156 272C158.209 272 160 273.791 160 276C160 278.209 158.209 280 156 280H124C121.791 280 120 278.209 120 276C120 273.791 121.791 272 124 272H156Z"
          fill="#2974C4"
        />
        <path
          d="M136 292C136 289.791 134.209 288 132 288H124C121.791 288 120 289.791 120 292C120 294.209 121.791 296 124 296H132C134.209 296 136 294.209 136 292Z"
          fill="#2974C4"
        />
        <path
          d="M108 288C110.209 288 112 289.791 112 292C112 294.209 110.209 296 108 296H100C97.7909 296 96 294.209 96 292C96 289.791 97.7909 288 100 288H108Z"
          fill="#2974C4"
        />
        <path
          d="M224 276C224 273.791 222.209 272 220 272H196C193.791 272 192 273.791 192 276C192 278.209 193.791 280 196 280H220C222.209 280 224 278.209 224 276Z"
          fill="#2974C4"
        />
        <path
          d="M180 272C182.209 272 184 273.791 184 276C184 278.209 182.209 280 180 280H172C169.791 280 168 278.209 168 276C168 273.791 169.791 272 172 272H180Z"
          fill="#2974C4"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M159 200C153.078 200 147.907 203.217 145.141 208L150.056 208C152.253 205.545 155.446 204 159 204C162.554 204 165.747 205.545 167.944 208L172.859 208C170.093 203.217 164.922 200 159 200Z"
        fill="#2974C4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M130 161.5C127.791 161.5 126 163.291 126 165.5V186.5C126 188.709 127.791 190.5 130 190.5H151C153.209 190.5 155 188.709 155 186.5V179.5H165V186.5C165 188.709 166.791 190.5 169 190.5H190C192.209 190.5 194 188.709 194 186.5V165.5C194 163.291 192.209 161.5 190 161.5H169C166.791 161.5 165 163.291 165 165.5V176.5H155V165.5C155 163.291 153.209 161.5 151 161.5H130ZM151 164.5H130C129.448 164.5 129 164.948 129 165.5V186.5C129 187.052 129.448 187.5 130 187.5H151C151.552 187.5 152 187.052 152 186.5V165.5C152 164.948 151.552 164.5 151 164.5ZM190 164.5H169C168.448 164.5 168 164.948 168 165.5V186.5C168 187.052 168.448 187.5 169 187.5H190C190.552 187.5 191 187.052 191 186.5V165.5C191 164.948 190.552 164.5 190 164.5Z"
        fill="#2974C4"
      />
    </g>
    <defs>
      <clipPath id="clip0_2667_52841">
        <rect width="320" height="320" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export { TagscapeError };
